import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import PasswordProtection from './components/PasswordProtection';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Landing from './pages/Landing';
import OurLives from './pages/OurLives';
import Schedule from './pages/Schedule';
import TravelAndStay from './pages/TravelAndStay';
import WardrobePlanner from './pages/WardrobePlanner';
import Gifting from './pages/Gifting';
import FAQ from './pages/FAQ';
import RSVPPage from './pages/RSVP';
import EventServicesPage from './pages/EventServices';
import ThingsToDo from './pages/ThingsToDo';
import { useImageProtection } from './hooks/useImageProtection';

const AuthenticatedApp: React.FC<{ justAuthenticated: boolean }> = ({ justAuthenticated }) => {
  const navigate = useNavigate();
  
  // Enable image protection
  useImageProtection();

  useEffect(() => {
    // Only redirect to home page immediately after authentication
    if (justAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [justAuthenticated, navigate]);

  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/our-lives" element={<OurLives />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/travel-and-stay" element={<TravelAndStay />} />
          <Route path="/things-to-do" element={<ThingsToDo />} />
          <Route path="/wardrobe-planner" element={<WardrobePlanner />} />
          <Route path="/gifting" element={<Gifting />} />
          <Route path="/rsvp" element={<RSVPPage />} />
          <Route path="/event-services" element={<EventServicesPage />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </Layout>
    </>
  );
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [justAuthenticated, setJustAuthenticated] = useState(false);

  const handleAuthenticate = () => {
    setIsAuthenticated(true);
    setJustAuthenticated(true);
  };

  // Reset the justAuthenticated flag after the first render
  useEffect(() => {
    if (justAuthenticated) {
      const timer = setTimeout(() => {
        setJustAuthenticated(false);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [justAuthenticated]);

  return (
    <Router>
      {!isAuthenticated ? (
        <PasswordProtection onAuthenticate={handleAuthenticate} />
      ) : (
        <AuthenticatedApp justAuthenticated={justAuthenticated} />
      )}
    </Router>
  );
}

export default App;
